module.exports = __webpack_public_path__ + "static/gallery_kerry_6-119d5160bbb571b92d86ec5e60b0d9de.jpg";